import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useCallback, useMemo } from 'react';
import { makeStyles } from '@mui/styles';
import { Page, FilesDropzone, Header, Alert } from 'components';
import { enqueueSnackbar } from 'actions';
import { Card, CardContent,	TextField, Grid, Button, colors } from '@mui/material';

import IncidentTrackerDialog from './components/IncidentTrackerDialog';
import IncidentTrackerTable from './components/IncidentTrackerTable';

import { ExportIncidents, GetIncidentTable, ToggleIncidentTrackerDialog } from '../../actions/IncidentTrackerActions.js';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const IncidentTracker = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const incidentTrackerDialogVisibility = useSelector((state) => state.incidentTrackerReducer.incidentTrackerDialogVisibility);
	const selectedIncidentId = useSelector((state) => state.incidentTrackerReducer.selectedIncidentId);
	const selectedIncidentSubmitter = useSelector((state) => state.incidentTrackerReducer.selectedIncidentSubmitter);
	const incidentTable = useSelector((state) => state.incidentTrackerReducer.incidentTable);

	const _onCreateIncidentClick = () => {
		dispatch(ToggleIncidentTrackerDialog(true, 0, ''));
	};

	const _onCloseIncidentTrackerDialog = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleIncidentTrackerDialog(false, 0, ''));
		}
	};

	const _onExportIncidentsClick = () => {
		dispatch(ExportIncidents());
	};

	useEffect(() => {
		dispatch(GetIncidentTable());
	}, []);

	return (
		<Page className={classes.root} title="Incident Tracker">
			<Header module="Incident Tracker" view="Incident Tracker" />
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={6} xs={6}>
					<Button
						className={classes.agreeButton}
						color="primary"
						onClick={_onCreateIncidentClick}
						variant="contained"
						size="small"
					>
						Create Incident
					</Button>
				</Grid>
				<Grid item lg={6} xs={6}>
					<Grid container direction="row-reverse">
						<Button
							className={classes.generate}
							color="primary"
							onClick={_onExportIncidentsClick}
							variant="contained"
							size="small"
						>
							Export Incidents
						</Button>
					</Grid>
				</Grid>
				<Grid item lg={12} xs={12}>
					<IncidentTrackerTable className={classes.results} data={incidentTable} />
				</Grid>
			</Grid>
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					{incidentTrackerDialogVisibility && (
						<IncidentTrackerDialog
							onClose={_onCloseIncidentTrackerDialog}
							open={incidentTrackerDialogVisibility}
							incidentId={selectedIncidentId}
							submitter={selectedIncidentSubmitter}
						/>
					)}
				</Grid>
			</Grid>
		</Page>
	);
};

export default IncidentTracker;
